var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["gift_app_no"]
                              },
                              model: {
                                value: _vm.model.app,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "app", $$v)
                                },
                                expression: "model.app"
                              }
                            },
                            _vm._l(_vm.appOptions, function(value, key) {
                              return _c(
                                "a-select-option",
                                { key: key, attrs: { value: key } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(value) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["column.jobNumber"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "user"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["column.jobNumber"],
                              maxLength: 30
                            },
                            model: {
                              value: _vm.model.user,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "user", $$v)
                              },
                              expression: "model.user"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift.user.id.card.number"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "idCardNumber"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift.user.id.card.number"],
                              maxLength: 30
                            },
                            model: {
                              value: _vm.model.idCardNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "idCardNumber", $$v)
                              },
                              expression: "model.idCardNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["portal.personalName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["portal.personalName"],
                              maxLength: 30
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["gift.user.paying.legal.person"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "payingLegalPerson"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift.user.paying.legal.person"],
                              maxLength: 30
                            },
                            model: {
                              value: _vm.model.payingLegalPerson,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "payingLegalPerson", $$v)
                              },
                              expression: "model.payingLegalPerson"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "depart.management.artificialPerson"
                              ],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "company"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language[
                                  "depart.management.artificialPerson"
                                ],
                              maxLength: 30
                            },
                            model: {
                              value: _vm.model.company,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "company", $$v)
                              },
                              expression: "model.company"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_start_point"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "points"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_user_start_point"],
                              min: 1,
                              max: 999999999
                            },
                            model: {
                              value: _vm.model.points,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "points", $$v)
                              },
                              expression: "model.points"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_start_time"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "startTime"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              "show-time": "",
                              placeholder:
                                _vm.language["column.pleaseChoose"] +
                                _vm.language["gift_user_start_time"]
                            },
                            model: {
                              value: _vm.model.startTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "startTime", $$v)
                              },
                              expression: "model.startTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_deadline"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "endTime"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              "show-time": "",
                              placeholder:
                                _vm.language["column.pleaseChoose"] +
                                _vm.language["gift_user_deadline"]
                            },
                            model: {
                              value: _vm.model.endTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "endTime", $$v)
                              },
                              expression: "model.endTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }